import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { auth, googleProvider } from '../firebase';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithPopup
} from 'firebase/auth';
import LoginImage from '../assets/images/login/Login-DonJuan_1.png';
import '../css/login.css';

export default function Auth() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLogin, setIsLogin] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  // Get the previous location or default to home page
  const from = location.state?.from?.pathname || '/';

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isLogin) {
        // Login with email/password
        await signInWithEmailAndPassword(auth, email, password);
      } else {
        // Sign up with email/password
        await createUserWithEmailAndPassword(auth, email, password);
      }
      // Redirect to previous location after successful auth
      console.log('From: ' + from)
      navigate(from, { replace: true });
    } catch (error) {
      alert(`Error: ${error.message}`);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
      navigate(from, { replace: true });
    } catch (error) {
      alert(`Error: ${error.message}`);
    }
  };

  return (
    <div className="container mainMargin">
      <div className="row">
        <div className="col-md-6">
          <img src={LoginImage} alt="Ingresa para continuar con tu aventura" className='img-fluid login-image'/>
        </div>
        <div className="col-md-6">
          <div className={`login-form shadow ${isLogin ? 'login' : 'create'}`}>
            <h2>{isLogin ? 'Reanuda tu aventura' : 'Únete a la aventura'}</h2>
            <p>
              {isLogin ? '¡Accede al todo el contenido del sitio! Tus tarjetas de personajes, tus capítulos desbloqueados...' : 'Al registrate en el sitio podrás tener acceso a todo el contenido del sitio e ir guardando tu progeso mientras desbloqueas capítulos y el arte de los personajes.'}
            </p>

            <div className="text-center mt-4">
              <button
                onClick={handleGoogleLogin}
                className="btn google-btn"
              >
                <img src="https://diadelavida.com/images/layout/login_google.png" alt="Google" />
                <span className='Galindo'>{isLogin ? 'Ingresar con Google' : 'Crear cuenta con Google'}</span> <br />
                <small className="text-muted">Recomendado</small>
              </button>
            </div>

            <h5 className='mt-5 text-center'>
              {isLogin ? 'Ingresar con Correo Electrónico' : 'Registrarse con Correo Electrónico'}
            </h5>
            <form onSubmit={handleSubmit}>
              <input
                type="email"
                placeholder="Correo Electrónico"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-control mb-3"
                required
              />
              <input
                type="password"
                placeholder="Contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-control mb-3"
                required
              />
              <button type="submit" className="btn w-100 Galindo btn-login">
                {isLogin ? 'Ingresar' : 'Registrarte'}
              </button>
            </form>

            <div className="text-center mt-3">
              <button
                onClick={() => setIsLogin(!isLogin)}
                className="btn btn-link Galindo"
              >
                <small>
                {isLogin ? '¿Aun no eres parte de la aventura? Crea una nueva cuenta' : '¿Ya tienes cuenta? Ingresa aquí'}
                </small>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}